export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Associer un animateur"])},
        "sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Animateur"])},
        "no_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun animateur"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enregistrer"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assign a sales field manager"])},
        "sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sales field manager"])},
        "no_sales_manager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No sales field manager"])},
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Save"])}
      }
    }
  })
}
